import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact">
      <Helmet>
        <title>İletişim | Ünal Döviz - Gaziemir İletişim Bilgileri</title>
        <meta name="description" content="Ünal Döviz Sınırlı Yetkili Müessese A.Ş. iletişim bilgileri. Atıfbey Mah. 5 Sk. No: 90/B, Gaziemir, İzmir. Telefon: 0 232 252 53 90." />
        <meta name="keywords" content="Ünal Döviz iletişim, Gaziemir döviz bürosu, İzmir döviz bürosu adres, B grubu yetkili müessese" />
        <link rel="canonical" href="https://unaldoviz.com/iletisim" />
        <meta property="og:title" content="İletişim | Ünal Döviz - Gaziemir" />
        <meta property="og:description" content="Ünal Döviz Sınırlı Yetkili Müessese A.Ş. Gaziemir, İzmir iletişim bilgileri." />
        <meta property="og:url" content="https://unaldoviz.com/iletisim" />
        <meta property="og:type" content="website" />
      </Helmet>
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="contact-hero-content text-center">
            <h1 className="contact-title">İletişim</h1>
            <p className="contact-subtitle">
              Size nasıl yardımcı olabiliriz? Bizimle iletişime geçin
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info section-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="info-card card">
                <div className="info-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="url(#locationGradient)"/>
                    <defs>
                      <linearGradient id="locationGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#667eea"/>
                        <stop offset="100%" stopColor="#764ba2"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h3 className="info-title">Adresimiz</h3>
                <p className="info-text">
                  Atıfbey Mah. 5 Sk. <br />
                  No: 90/B<br />
                  Gaziemir - İzmir
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="info-card card">
                <div className="info-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="url(#phoneGradient)"/>
                    <defs>
                      <linearGradient id="phoneGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#f093fb"/>
                        <stop offset="100%" stopColor="#f5576c"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h3 className="info-title">Telefon</h3>
                <p className="info-text">
                  <a href="tel:+902322525390">0 232 252 53 90</a><br />
                  <a href="tel:+902322525391">0 232 252 53 91</a>
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="info-card card">
                <div className="info-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="url(#emailGradient)"/>
                    <defs>
                      <linearGradient id="emailGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#4facfe"/>
                        <stop offset="100%" stopColor="#00f2fe"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h3 className="info-title">E-posta</h3>
                <p className="info-text">
                  <a href="mailto:info@unaldoviz.com">info@unaldoviz.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Branches Section */}
      <section className="branches section-padding">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">Şubelerimiz</h2>
            <p className="section-description">
              Gaziemir'deki tek merkez şubemizle hizmetinizdeyiz
            </p>
          </div>
          <div className="branches-grid">
            {/* Merkez Şube */}
            <div className="branch-card main-branch">
              <div className="branch-content">
                <h3 className="branch-title">Ünal Döviz Sınırlı Yetkili Müessese A.Ş.</h3>
                <div className="branch-info">
                  <div className="info-item">
                    <div className="info-icon">📍</div>
                    <div className="info-text">
                      <strong>Atıfbey Mah. 5 Sk. No: 90/B</strong><br />
                      Gaziemir - İzmir
                    </div>
                  </div>
                  <div className="info-item">
                    <div className="info-icon">📞</div>
                    <div className="info-text">
                      <strong>0 232 252 53 90</strong><br />
                      0 232 252 53 91
                    </div>
                  </div>
                </div>
                <div className="branch-map">
                  <iframe
                    src="https://www.google.com/maps?q=At%C4%B1fbey+Mahallesi+5+Sokak+No+90%2FB+Gaziemir+%C4%B0zmir&output=embed"
                    width="100%"
                    height="200"
                    style={{ border: 0, borderRadius: '12px' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Merkez Şube Haritası"
                  ></iframe>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;